import { createContext, useContext, useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [btcEur, setBtcEur] = useState(0);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("cr_token");
    const cachedPrice = parseFloat(localStorage.getItem("cr_btc_eur") || "0");
    if (cachedPrice) setBtcEur(cachedPrice);
    if (!token) {
      setLoading(false);
      return;
    }
    api
      .get("/auth/me")
      .then((res) => {
        const { btc_eur, ...u } = res.data;
        setUser(u);
        if (btc_eur) {
          setBtcEur(btc_eur);
          localStorage.setItem("cr_btc_eur", String(btc_eur));
        }
      })
      .catch(() => {
        localStorage.removeItem("cr_token");
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const applyAuth = (data) => {
    localStorage.setItem("cr_token", data.token);
    setUser(data.user);
    if (data.btc_eur) {
      setBtcEur(data.btc_eur);
      localStorage.setItem("cr_btc_eur", String(data.btc_eur));
    }
  };

  const login = async (email, password) => {
    try {
      const { data } = await api.post("/auth/login", { email, password });
      applyAuth(data);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const register = async (payload) => {
    try {
      const { data } = await api.post("/auth/register", payload);
      applyAuth(data);
      return { ok: true, user: data.user };
    } catch (e) {
      return { ok: false, error: formatApiError(e) };
    }
  };

  const logout = () => {
    localStorage.removeItem("cr_token");
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const { data } = await api.get("/auth/me");
      const { btc_eur, ...u } = data;
      setUser(u);
      if (btc_eur) {
        setBtcEur(btc_eur);
        localStorage.setItem("cr_btc_eur", String(btc_eur));
      }
    } catch { /* ignore */ }
  };

  return (
    <AuthContext.Provider value={{ user, btcEur, loading, login, register, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
